"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconBulletList = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M12.61 22.17A6.15 6.15 0 1 0 6.47 16a6.15 6.15 0 0 0 6.14 6.15zm0-9.44A3.29 3.29 0 1 1 9.32 16a3.29 3.29 0 0 1 3.29-3.29zm0 0M12.61 41.14A6.14 6.14 0 1 0 6.47 35a6.15 6.15 0 0 0 6.14 6.14zm0-9.43A3.29 3.29 0 1 1 9.32 35a3.29 3.29 0 0 1 3.29-3.29zm0 0M12.61 60.12A6.14 6.14 0 1 0 6.47 54a6.15 6.15 0 0 0 6.14 6.14zm0-9.44A3.29 3.29 0 1 1 9.32 54a3.29 3.29 0 0 1 3.29-3.29zm0 0M27 17.45h35.1a1.43 1.43 0 0 0 0-2.87H27a1.43 1.43 0 0 0 0 2.87zm0 0M27 36.43h35.1a1.43 1.43 0 1 0 0-2.87H27a1.43 1.43 0 1 0 0 2.87zm0 0M27 55.4h35.1a1.43 1.43 0 0 0 0-2.87H27a1.43 1.43 0 0 0 0 2.87zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconBulletList.displayName = 'IconBulletList';
var _default = IconBulletList;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/bullet-list.js
// module id = 549
// module chunks = 0